import get from 'lodash/get'

export default function co2EndpointConverter({ data }) {
  const thresholds = get(data, ['attributes', 'thresholds'])
  const dataSet = get(data, ['attributes', 'data-set'])
  const points = get(dataSet, ['points'])
  const unit = get(dataSet, ['unit'])
  return { thresholds, points, unit }
}
